import React from "react";
import PropTypes from "prop-types";
import styled from "@emotion/styled";
import { AnimatePresence, motion } from "framer-motion";

//styles
import { Animation, Colors } from "../../styles";

const MediaGridNoResults = ({ text }) => {
	return (
		<AnimatePresence>
			<Text
				initial={"initial"}
				animate={"animate"}
				exit={"initial"}
				variants={Animation.cards.opacityVariants}
				transition={{ delay: 0.3 }}
			>
				{text}
			</Text>
		</AnimatePresence>
	);
};
MediaGridNoResults.propTypes = {
	text: PropTypes.string,
	color: PropTypes.string,
};

export default MediaGridNoResults;

const Text = styled(motion.h3)`
	text-align: center;
	color: ${Colors.base.black};
`;
